export default __webpack_public_path__ + "static/media/headphones-R.11754f5f.svg";